export default __webpack_public_path__ + "static/media/schedule.cbb4dc75.svg";